Promise.all([import('scripts/marmalade/classes/page-filters')]).then(_ref => {
  let [modulePageFilters] = _ref;
  // Define the components
  const PageFiltersController = modulePageFilters.default;

  // Find the page
  const page = document.querySelector('.js-region');
  // Find the search list
  const list = page.querySelector('.js-region__list');
  // Find the search form
  const form = page.querySelector('.js-region__form');
  // Find the search results
  const results = page.querySelector('.js-region__results');

  // Create a new FilterController
  const PageFilters = new PageFiltersController(form);

  /* ----------------------------------
  Document setup
  ---------------------------------- */

  // When the form is submitted
  PageFilters.on('submit', () => {
    // Add a spinner class to the list
    list.classList.add('loading', 'spinner');
    // Smooth scroll the page to the top of the results
    window.ScrollController.scrollTo(window.getOffsetY(results) - 200, 500);
  });

  // When the filter is applied and loads successfully
  PageFilters.on('success', response => {
    // Append the results to the list
    results.innerHTML = response;
  });
  PageFilters.on('pageChanged', () => {
    window.ScrollController.scrollTo(window.getOffsetY(results) - 200, 500);
  });

  // When the filter is applied but there is an error
  PageFilters.on('error', response => {
    // Tell the user there was an error
    console.warn('There was an error loading the results. Error code:', response);
    results.innerHTML = `<p class="text-center">There was an error loading the results.</p>`;
  });

  // When the page filters have completed
  PageFilters.on('complete', () => {
    // Remove all the loading classes
    list.classList.remove('loading', 'spinner');
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});